// routes/generator.chat-editing.creator.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/generator.chat-editing.creator')

export const handle = { name: 'generator/chat-editing/creator' }

export default dynamic(getClientModule, { ssr: false })
